import { isAxiosError } from 'axios';

/**
 * What the server said when it refused a request, if it said why. The server writes the reason of a refusal (a 4xx) for the person, for
 * instance that a form changed since it was shown, so that is what to show. The body of a server error (a 5xx) is not written for the
 * person and is never shown.
 */
export function explainedRefusal(error: Error): string | undefined {
  if (!isAxiosError<{ message?: string }>(error)) return undefined;

  const status = error.response?.status;
  if (status === undefined || status < 400 || status >= 500) return undefined;

  const message = error.response?.data?.message;
  return typeof message === 'string' && message.trim() !== '' ? message : undefined;
}
